import type { TestType } from '@prisma/client';
import { match } from 'ts-pattern';

export function getTestTypeFriendlyName(type?: TestType) {
  return match(type)
    .with('WEB', () => 'Web')
    .with('WEB_MOBILE', () => 'Mobile Web')
    .with('MOBILE_APP', () => 'Mobile App')
    .with(undefined, () => 'Unknown')
    .exhaustive();
}
